export default "__VITE_ASSET__BJAF2DMg__"